import React, { useState } from 'react';
import * as FaIcons from 'react-icons/fa';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useUsuariosManagement } from '../../hooks/useUsuariosManagement';
import UserList from '../../components/Usuarios/UserList';
import EditPermissionsModal from '../../components/Usuarios/EditPermissionsModal';

const Usuarios = () => {
  // Usar el hook completo de gestión de usuarios
  const {
    usuarios,
    permisos,
    userPermissions,
    modulos,
    loading,
    loadingUpdate,
    error,
    updatePermission,
    canEditUsers,
    canAdminUsers,
    currentUser
  } = useUsuariosManagement();

  // Estado para el modal de edición de permisos
  const [modalState, setModalState] = useState({
    isOpen: false,
    usuario: null,
    modulo: null,
    moduloData: null
  });

  // Función para manejar la actualización de permisos
  const handleUpdatePermission = async (userId, modulo, permiso, action) => {
    try {
      const result = await updatePermission(userId, modulo, permiso, action);
      if (!result.success) {
        alert(`Error al ${action === 'add' ? 'agregar' : 'eliminar'} permiso: ${result.error}`);
      }
      return result;
    } catch (error) {
      console.error('Error updating permission:', error);
      alert(`Error al ${action === 'add' ? 'agregar' : 'eliminar'} permiso`);
      return { success: false, error: error.message };
    }
  };

  // Funciones para manejar el modal - sobrecarga para manejar ambos casos
  const handleEditPermissions = (usuario, moduloName = null) => {
    if (!canEditUsers()) return;
    
    // Si solo recibe un usuario (desde el botón general), abrir modal general
    if (!moduloName) {
      setModalState({
        isOpen: true,
        usuario,
        modulo: null,
        moduloData: null
      });
      return;
    }
    
    // Si recibe usuario y módulo específico (desde badge), abrir modal específico
    const moduloData = modulos.find(m => m.modulo === moduloName);
    setModalState({
      isOpen: true,
      usuario,
      modulo: moduloName,
      moduloData
    });
  };

  const handleCloseModal = () => {
    setModalState({
      isOpen: false,
      usuario: null,
      modulo: null,
      moduloData: null
    });
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
      {/* CSS para animaciones */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <SimpleMantenedorLayout
        mantenedorId="usuarios"
        title="Gestión de Usuarios"
        subtitle="Administra los usuarios del sistema y sus permisos por módulo"
        icon={<FaIcons.FaUsers />}
        iconColor="#007bff"
        showBackButton={false}
        breadcrumbs={[
          { label: 'Usuarios' }
        ]}
      >
        {/* Loading overlay */}
        {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #3498db',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                animation: 'spin 2s linear infinite',
                margin: '0 auto 10px'
              }}></div>
              <p>Cargando usuarios, permisos y módulos...</p>
            </div>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div style={{ 
            padding: '20px', 
            backgroundColor: '#ffebee',
            borderRadius: '6px',
            marginBottom: '20px',
            border: '1px solid #f48fb1'
          }}>
            <h3 style={{ color: '#c62828', margin: '0 0 8px 0' }}>❌ Error al cargar datos</h3>
            <p style={{ margin: '0', color: '#c62828' }}>{error}</p>
          </div>
        )}

        {/* Lista de usuarios */}
        <UserList
          usuarios={usuarios}
          modulos={modulos}
          permisos={permisos}
          onEditPermissions={handleEditPermissions}
          canEditUsers={canEditUsers}
          loading={loading}
        />

        {/* Modal de Permisos */}
        <EditPermissionsModal
          isOpen={modalState.isOpen}
          onClose={handleCloseModal}
          usuario={modalState.usuario}
          modulo={modalState.modulo}
          moduloData={modalState.moduloData}
          todosLosPermisos={permisos}
          onUpdatePermission={handleUpdatePermission}
          loading={loadingUpdate}
          canAdminUsers={canAdminUsers}
        />
      </SimpleMantenedorLayout>
    </div>
  );
};

export default Usuarios;
